import { getWarehouseData } from "@crescentParts/Services/WarehouseDataService";
import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import WarehouseDataState from "@crescentParts/Store/Data/WarehouseData/WarehouseDataState";
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";


type Props = {
    apiResult: WarehouseDataState;
};

type HandlerType = CustomHandler<WarehouseDataState, Props>

export const GetWarehouseData: HandlerType = async props => {
    try {
        props.apiResult = await getWarehouseData();
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            // props.paramater.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
}

export const onCompleteGetWarehouseData: HandlerType = props => {
    props.dispatch({
        type: "Custom/WarehouseData/setWarehouseData",
        warehouseData: props.apiResult
    });
}

export const chain = [GetWarehouseData, onCompleteGetWarehouseData]

const WarehouseDataHandler = createHandlerChainRunner(chain, "warehouseDataHandler");

export default WarehouseDataHandler;



